import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-proxy",
  "use": "icon-proxy-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-proxy\"><defs><style type=\"text/css\"></style></defs><path d=\"M937.5 326.9v-172h-196v67h-270v272H352.4C343.5 424.1 283.7 370 211.5 370c-78.3 0-142 63.7-142 142s63.7 142 142 142c71.9 0 131.5-53.7 140.7-123.1h119.2v268h270v70h196v-172h-196v64h-233v-230h233v67h196v-172h-196v68h-233v-235h233v68h196.1zM211.5 614c-56.2 0-102-45.8-102-102s45.8-102 102-102 102 45.8 102 102-45.7 102-102 102z m560 112.9h136v112h-136v-112z m0-271h136v112h-136v-112z m0-271h136v112h-136v-112z\" p-id=\"6853\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/proxy.svg
// module id = O9+4
// module chunks = 144